import { Tag } from '@s4l/ds'
import { IconArrowLineDown } from '@s4l/icons/IconArrowLineDown'
import { useS4LContext } from '@s4l/react-context'
import cn from 'classnames'
import React from 'react'
import { useDispatch } from 'react-redux'
import { routes } from 'src/constants/routes'
import { enableInsuranceAction } from 'src/effects/Availability/actions'
import { PATH_IMAGES_CDN } from 'src/constants/environment'
import { affiliateHasLogo } from 'src/comps/Affiliate/functions'
import Image from 'src/comps/Image'
import InsuranceSelector from './InsuranceSelector'
import OfferConditions from './OfferConditions'
import OfferResponsivePriceAndButtons from './OfferResponsivePriceAndButton'
import styles from './styles.module.css'

interface OfferResponsiveProps {
  board: any
  isLoading?: boolean
  isMultiRoom: boolean
  isSelected: boolean
  nights: number
  onClick: (arg: any) => void
  prime?: boolean
  showAffiliate: boolean
  affiliateId?: string
  showMore?: JSX.Element
  bestPrice?: boolean
  isFromMeta?: boolean
}

const OfferResponsive = ({
  board,
  isLoading = false,
  isMultiRoom,
  isSelected,
  nights,
  onClick,
  prime = false,
  showAffiliate,
  affiliateId,
  showMore,
  bestPrice = false,
  isFromMeta = false,
}: OfferResponsiveProps) => {
  const pageId = routes.detail.page
  const dispatch = useDispatch()
  const { i18n } = useS4LContext()

  const handleClickBook = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()

    if (!isLoading) {
      onClick({ board, isRemove: isSelected })
    }
  }

  const handleClickInsurance = (isEnable: boolean) => {
    dispatch(
      enableInsuranceAction({
        availabilityId: board.availabilityId,
        insuranceSelected: isEnable,
      })
    )
  }

  return (
    <div
      className={cn(styles.offerContainer, {
        [styles.offerHighlighted]: showAffiliate,
      })}
    >
      <div className={styles.boardContainer}>
        {showAffiliate && (
          <div className={styles.yourSelectionTagContainer}>
            {isFromMeta && affiliateHasLogo(affiliateId) ? (
              <Tag color="var(--color-neutral-800)" bgColor="var(--color-neutral-300)" size="s">
                <div className={styles.affiliateTagContent}>
                  <span>{i18n.formatMessage({ id: 'global.found-on' })}</span>
                  <Image
                    alt={`${affiliateId}-logo`}
                    src={`${PATH_IMAGES_CDN}/affiliates/160524-aid-${affiliateId}.svg`}
                    layout="contain"
                    height={16}
                    className={styles.affiliateLogo}
                  />
                </div>
              </Tag>
            ) : (
              <Tag
                icon={<IconArrowLineDown />}
                color="var(--color-base-white)"
                bgColor="var(--color-neutral-800)"
                size="s"
              >
                {i18n.formatMessage({ id: 'global.your-choice' })}
              </Tag>
            )}
          </div>
        )}
        <OfferConditions
          code={board.code}
          cancellation={board.cancellation}
          currency={board.currency}
          name={board.boardName}
          paymentPolicy={board.paymentPolicy}
          payRate={board.payRate}
          isMobile={board.isMobile}
          bestPrice={bestPrice}
        />
        {board.insurance && (
          <InsuranceSelector
            {...board.insurance}
            isSelected={board.insuranceSelected}
            onClick={handleClickInsurance}
            consumer={pageId}
          />
        )}
      </div>
      <OfferResponsivePriceAndButtons
        board={board}
        isLoading={isLoading}
        isMultiRoom={isMultiRoom}
        isSelected={isSelected}
        nights={nights}
        onClick={handleClickBook}
        prime={prime}
        showMore={showMore}
      />
    </div>
  )
}

export default OfferResponsive
